import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import ContentBox from '../../../molecules/ContentBox';
import AutocompleteComponent from '../../../atoms/AutocompleteComponent';
import { Button, Space, Table, TableColumnsType, TableProps } from 'antd';
import FileUpload from '../../../atoms/FileUploadComponent';
import ActionButton from '../../../atoms/ButtonComponent';
import { utils, writeFile } from 'xlsx';
import cupomStore from '../../../../stores/cupomStore';
import productStore from '../../../../stores/productStore';
import campaingStore from '../../../../stores/campaingStore';
import { getUniqueFilters } from '../../../../utils/functions';
import { DeleteOutlined } from '@ant-design/icons';
import administratorStore from '../../../../stores/administratorStore';
import { AdministratorModel } from '../../../../types/Administrator';
import { DEFAULT_PAGE_SIZE } from '../../../../config/config';
import ModalComponent from '../../../organisms/ModalComponent';


interface DataType {
    [x: string]: any;
    displayUnits: any;
    baseQty: string;
    name: string;
    uuid: any;
    key: React.Key;
}

interface AddAdministratorProps {
    administrator: any;
}

const defaultparams = {
    size: 20,
    page: 0,
    sort: 'created,desc',
    search: '',
}

const AddAdministrator: React.FC<AddAdministratorProps> = observer(({ administrator }) => {
    const [autocompleteOptions, setAutocompleteOptions] = useState<any>([]);
    const [selectedProduct, setSelectedProduct] = useState<any>([]);
    const { childAdministrator, page, size, totalElements, loadingChild } = administratorStore;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [itemSelected, setItemSelected] = useState<any>();

    useEffect(() => {
        if (administrator !== null) {
            administratorStore.getChildAdministrator(administrator?.uuid, defaultparams);
        }
    }, [administrator])

    const handleSearch = async (searchText: string) => {
        setAutocompleteOptions([]);
        if (searchText.length > 3) {
            try {
                const response = await administratorStore.getChildAdministratorByTerm(searchText);
                setAutocompleteOptions(response);
                // Aqui você pode mapear a resposta para opções, se necessário
            } catch (error) {
                console.error('Erro ao buscar administrador:', error);
            }
        }
    };


    const onChange: TableProps<DataType>['onChange'] = async (pagination, filters, sorter, extra) => {
        const params = buildParams(pagination);
        await administratorStore.getChildAdministrator(administrator.uuid, params);
    };

    const buildParams = (
        pagination: any,
    ) => {
        const currentPage = pagination.current - 1;
        const newPageSize = pagination.pageSize || DEFAULT_PAGE_SIZE;

        const params = {
            size: pagination.pageSize || newPageSize,
            page: pagination.current ? currentPage : 0,
        };

        return params;
    };


    // Validar
    const addProduct = () => {
        if (selectedProduct.option) {
            administratorStore.addChildAdministratorAction(selectedProduct.option);
        }
    }

    const columns: TableColumnsType<DataType> = [
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Cargo',
            dataIndex: 'role',
            key: 'role',
            render: (text, record) => (
                <Space className="cursor-pointer" onClick={() => showModal(record)}>
                    <div >{record?.role?.name}</div>
                </Space>
            ),
        },
        {
            title: 'Deletar',
            dataIndex: 'delete',
            key: 'delete',
            align: 'center',
            width: 80,
            render: (text, record) => (
                <Space className="cursor-pointer" onClick={() => showModal(record)}>
                    <div ><DeleteOutlined /></div>
                </Space>
            ),
        },
    ];

    const showModal = (record: any) => {
        setItemSelected(record);
        setIsModalOpen(true);
    };

    const handleDeleteItem = () => {
        administratorStore.removeChildAdminstrator(itemSelected);
        setIsModalOpen(false);
    };

    return (
        <>
            <ContentBox className="mb-4 p-6" borderCustom='rounded-b-lg' title="Adicionar Administradores" description='Adicionar administrador Associado'>
                <div className="flex pt-3 gap-4 items-end">
                    <AutocompleteComponent
                        label="Buscar Admistrador"
                        name="searchTerm"
                        placeholder="Digite o nome do Administrador"
                        fetchOptions={handleSearch}
                        options={autocompleteOptions}
                        onChange={(value: any) => setSelectedProduct(value)}
                    />
                    <Button type='primary' onClick={() => addProduct()}>Adicionar</Button>
                    {/* <FileUpload onFileProcessed={handleFileProcessed} requiredColumns={['SKU']} />
                    <ActionButton icon actionType="export" onClick={() => handleExport()}>Baixar Planilha</ActionButton> */}
                </div>


                <div className="mt-4">
                    <Table
                        className="table-custom"
                        columns={columns}
                        dataSource={childAdministrator?.map((item: any, index: number) => ({
                            ...item,
                            key: item.uuid || index,
                        }))}
                        loading={loadingChild}
                        onChange={onChange}
                        size="middle"
                        bordered={false}
                        pagination={{
                            current: page + 1,
                            pageSize: size,
                            total: totalElements,
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '20', '40', '60'],
                        }}
                    />
                </div>
            </ContentBox>

            {isModalOpen && <ModalComponent
                title="Aviso"
                content={<p>Você deseja excluir o Administrador <b>{itemSelected?.name}</b>?</p>}
                isModalOpen={isModalOpen}
                handleOk={handleDeleteItem}
                handleCancel={() => setIsModalOpen(false)}
            />}
        </>
    );
});

export default AddAdministrator;
